import { useState } from 'react';
import axios from 'axios';
import { CalendarPlus, Check } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AddToCalendarButton = ({ bookingId, className = '' }) => {
  const { t } = useLanguage();
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API}/bookings/${bookingId}/calendar.ics`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      });
      const url = URL.createObjectURL(new Blob([res.data], { type: 'text/calendar' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = `booking-${bookingId.slice(0, 8)}.ics`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      setDone(true);
      setTimeout(() => setDone(false), 2200);
    } catch (e) {
      alert(e.response?.data?.detail || 'Failed to download calendar file');
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={download}
      disabled={busy}
      className={`flex items-center justify-center gap-1.5 text-xs font-semibold text-text-primary border border-border hover:bg-surface-muted rounded-full px-3 py-2 transition-colors disabled:opacity-50 ${className}`}
      data-testid={`add-to-calendar-${bookingId}`}
      title={t('addToCalendar.title', 'Add this booking to your calendar')}
    >
      {done ? <Check className="w-3.5 h-3.5 text-emerald-600" /> : <CalendarPlus className="w-3.5 h-3.5" />}
      {done ? t('addToCalendar.done', 'Saved!') : busy ? t('addToCalendar.loading', '…') : t('addToCalendar.cta', 'Add to Calendar')}
    </button>
  );
};

export default AddToCalendarButton;
